"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const crypto = require("crypto");
const uuidv5 = require("uuid/v5");
const classes_1 = require("./classes");
class GuidManager {
    static createDeterministicGuid(namespaceValue, name) {
        return this.createDeterministicGuidCore(namespaceValue, name);
    }
    static createDeterministicGuidCore(namespaceValue, name) {
        classes_1.Utils.throwIfEmpty(namespaceValue, "namespaceValue");
        classes_1.Utils.throwIfEmpty(name, "name");
        const hash = crypto.createHash("sha1");
        hash.update(name);
        const bytes = Array.prototype.slice.call(hash.digest(), 0, 16);
        return uuidv5(namespaceValue, bytes);
    }
}
exports.GuidManager = GuidManager;
GuidManager.DnsNamespaceValue = "9e952958-5e33-4daf-827f-2fa12937b875";
GuidManager.UrlNamespaceValue = "9e952958-5e33-4daf-827f-2fa12937b875";
GuidManager.IsoOidNamespaceValue = "9e952958-5e33-4daf-827f-2fa12937b875";
//# sourceMappingURL=guidmanager.js.map